import api from './client';
import type { Appointment } from 'types/garage/planning';

interface ApiAppointment {
  id: string;
  org_id: string;
  client_name: string;
  plate: string;
  category: string;
  date: string;
  start_hour: number;
  duration_hours: number;
  has_car_icon: boolean;
  has_mail_icon: boolean;
  ordre_id?: string;
  dossier_id?: string;
  type?: string;
}

function toFrontend(a: ApiAppointment): Appointment {
  return {
    id: a.id,
    clientName: a.client_name,
    plate: a.plate,
    category: a.category as Appointment['category'],
    date: a.date,
    startHour: a.start_hour,
    durationHours: a.duration_hours,
    hasCarIcon: a.has_car_icon,
    hasMailIcon: a.has_mail_icon,
    ordre_id: a.ordre_id,
    dossier_id: a.dossier_id,
    org_id: a.org_id,
    type: a.type as Appointment['type'],
  };
}

function toApi(a: Partial<Appointment> & { org_id?: string }): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  if (a.clientName !== undefined) out.client_name = a.clientName;
  if (a.plate !== undefined) out.plate = a.plate;
  if (a.category !== undefined) out.category = a.category;
  if (a.date !== undefined) out.date = a.date;
  if (a.startHour !== undefined) out.start_hour = a.startHour;
  if (a.durationHours !== undefined) out.duration_hours = a.durationHours;
  if (a.hasCarIcon !== undefined) out.has_car_icon = a.hasCarIcon;
  if (a.hasMailIcon !== undefined) out.has_mail_icon = a.hasMailIcon;
  if (a.ordre_id !== undefined) out.ordre_id = a.ordre_id;
  if (a.dossier_id !== undefined) out.dossier_id = a.dossier_id;
  if (a.org_id !== undefined) out.org_id = a.org_id;
  if (a.type !== undefined) out.type = a.type;
  return out;
}

export const appointmentsApi = {
  list: async (params?: { org_id?: string; date?: string; category?: string; limit?: number; offset?: number }): Promise<Appointment[]> => {
    const { data } = await api.get('/appointments', { params });
    return (data as ApiAppointment[]).map(toFrontend);
  },

  create: async (appointment: Omit<Appointment, 'id'> & { org_id: string }): Promise<Appointment> => {
    const { data } = await api.post('/appointments', toApi(appointment));
    return toFrontend(data);
  },

  update: async (id: string, updates: Partial<Appointment>): Promise<Appointment> => {
    const { data } = await api.patch(`/appointments/${id}`, toApi(updates));
    return toFrontend(data);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/appointments/${id}`);
  },
};
